import { normalizeCountryName } from './currencyDetection';
import { COUNTRY_LABEL_TO_TOPO_ID, TOPO_COUNTRY_BY_ID } from '../data/topoCountries';

/** Map a stored country label (device info, session, codes) to world-atlas numeric geo id. */
export function resolveCountryToTopoId(country: string | null | undefined): string | null {
  if (!country?.trim()) return null;

  const trimmed = country.trim();
  const normalized = normalizeCountryName(trimmed) || trimmed;

  const direct =
    COUNTRY_LABEL_TO_TOPO_ID[trimmed] ||
    COUNTRY_LABEL_TO_TOPO_ID[normalized] ||
    COUNTRY_LABEL_TO_TOPO_ID[trimmed.toUpperCase()] ||
    COUNTRY_LABEL_TO_TOPO_ID[normalized.toUpperCase()];
  if (direct && direct !== '?') return direct;

  const lower = normalized.toLowerCase();
  for (const [label, topoId] of Object.entries(COUNTRY_LABEL_TO_TOPO_ID)) {
    if (topoId === '?') continue;
    if (label.toLowerCase() === lower) return topoId;
  }

  for (const [topoId, topoName] of Object.entries(TOPO_COUNTRY_BY_ID)) {
    const tn = topoName.toLowerCase();
    if (tn === lower || tn.includes(lower) || lower.includes(tn)) {
      return topoId;
    }
  }

  return null;
}

export function getTopoCountryDisplayName(topoId: string): string {
  return TOPO_COUNTRY_BY_ID[topoId] || topoId;
}

/** Build geo-id → user count map from country label counts. */
export function buildDensityByTopoId(
  distribution: Map<string, number>
): Record<string, number> {
  const density: Record<string, number> = {};
  distribution.forEach((count, countryLabel) => {
    const topoId = /^\d{3}$/.test(countryLabel)
      ? countryLabel
      : resolveCountryToTopoId(countryLabel) || countryLabel;
    if (!topoId || topoId === '?') return;
    density[topoId] = (density[topoId] || 0) + count;
  });
  return density;
}
